module.exports = __webpack_public_path__ + "img/burkina-faso.64dc85d0.svg";